import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[lumFocusHighlight]',
})
export class LumFocusHighlightDirective {
  constructor(private el :ElementRef) {}

  @HostListener('click', ['$event'])
  handleClick(event :MouseEvent) {
    const inputElement = this.el.nativeElement as HTMLInputElement;

    if (inputElement.selectionStart !== inputElement.selectionEnd) {
      // If text is selected, deselect it.
      inputElement.selectionStart = inputElement.selectionEnd;
    } else {
      // Otherwise, select the text.
      inputElement.select();
    }

    // Prevent default click handling which can deselect the text
    event.preventDefault();
  }
}
